var _rect, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelaxing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.207031,
    y: 0.194824,
    width: 100,
    height: 100,
    rx: 50,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.207,
    cy: 50.1948,
    r: 44.5,
    stroke: "#F6E003"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17363_86626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9476 42.0287C69.8752 37.4572 66.1053 34.4348 61.5338 34.4781H60.6347C60.7322 35.0523 60.7972 35.6372 60.808 36.2331C60.808 37.8147 60.4722 39.3421 59.8114 40.7287C60.0497 40.7287 60.288 40.7287 60.5263 40.7612C61.0355 40.8154 61.5446 40.9129 62.0321 41.0754C62.6171 41.2704 63.1804 41.552 63.5921 42.007C63.8954 42.3537 64.0904 42.8086 64.1445 43.2636C64.2529 44.2711 63.5704 45.0186 62.7363 45.4735C61.653 46.0585 60.4397 46.351 59.2372 46.6002C56.3448 47.1852 53.3874 47.5318 50.4301 47.5318C47.4727 47.5318 44.5153 47.1852 41.6229 46.6002C40.4204 46.351 39.2071 46.0585 38.1238 45.4735C37.2897 45.0186 36.5964 44.2819 36.7156 43.2636C36.7697 42.7978 36.9647 42.3537 37.268 42.007C37.6689 41.5412 38.243 41.2704 38.828 41.0754C39.3155 40.9129 39.8246 40.8046 40.3338 40.7612C40.5829 40.7396 40.8321 40.7287 41.0812 40.7287C40.3879 39.2879 40.0304 37.7172 40.0954 36.1572C40.1171 35.5831 40.1929 35.0306 40.2904 34.4781H39.3263C34.7548 34.4348 30.9849 37.4572 29.9125 42.0287C29.0892 45.5385 31.2124 49.7092 35.0148 51.4317C37.4414 52.5366 40.0413 53.2408 42.7278 54.1832C42.2837 60.2713 41.8287 66.5219 41.3629 73H59.5189C59.0531 66.5219 58.5981 60.2713 58.1539 54.1832C60.8405 53.2408 63.4404 52.5366 65.867 51.4317C69.6693 49.6984 71.7926 45.5385 70.9693 42.0287H70.9476Z",
    fill: "#F6E003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4085 44.4877C55.0016 44.4985 58.6632 40.8262 58.6307 36.2438C58.5982 31.6615 54.9367 27.9783 50.4085 28C45.772 28.0216 42.4246 31.5748 42.2405 36.2438C42.0671 40.3712 45.6203 44.4769 50.4193 44.4985L50.4085 44.4877Z",
    fill: "#F6E003"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17363_86626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.4143,
    height: 45,
    fill: "white",
    transform: "translate(29.707 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelaxing);
export default __webpack_public_path__ + "static/media/Relaxing.d54b353085088eb3d7cd753900fb63df.svg";
export { ForwardRef as ReactComponent };